// extracted by mini-css-extract-plugin
export var container = "_aw-0";